// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3__I7","colCheckbox":"styles_colCheckbox__GABHT"};